/**
 * APPLICATION:THEG_MOVIES_LIBRARY — dedicated bottom-nav contract.
 * Canon: docs/applications/THEG_MOVIES_LIBRARY_UI_ARCHITECTURE_V1.md §2
 * Do NOT reuse enterprise-workspace-registry (Mrk|New|Apps|Exp|Sett).
 * AGENT:GROK_BOT — Step3 mobile UI nav gate 2026-10-01
 */
export type ThegMoviesNavTabId = "home" | "movies" | "search" | "chatgpt" | "jobs";

export type ThegMoviesNavTab = {
  id: ThegMoviesNavTabId;
  route: `/theg-movies/${ThegMoviesNavTabId}`;
  title: string;
  mobileLabel: "HOME" | "MOVIES" | "SEARCH" | "CHATGPT" | "JOBS";
  bottomNavigation: true;
  searchScope:
    | "THEG_HOME"
    | "THEG_MOVIES"
    | "THEG_SEARCH"
    | "THEG_CHATGPT"
    | "THEG_JOBS";
  focal: true;
};

/** Exactly five permanent bottom tabs, this order. Settings/profile via top-right menu only. */
export const THEG_MOVIES_LIBRARY_BOTTOM_NAV: readonly ThegMoviesNavTab[] = [
  {
    id: "home",
    route: "/theg-movies/home",
    title: "Home",
    mobileLabel: "HOME",
    bottomNavigation: true,
    searchScope: "THEG_HOME",
    focal: true,
  },
  {
    id: "movies",
    route: "/theg-movies/movies",
    title: "Movies",
    mobileLabel: "MOVIES",
    bottomNavigation: true,
    searchScope: "THEG_MOVIES",
    focal: true,
  },
  {
    id: "search",
    route: "/theg-movies/search",
    title: "Search",
    mobileLabel: "SEARCH",
    bottomNavigation: true,
    searchScope: "THEG_SEARCH",
    focal: true,
  },
  {
    id: "chatgpt",
    route: "/theg-movies/chatgpt",
    title: "ChatGPT",
    mobileLabel: "CHATGPT",
    bottomNavigation: true,
    searchScope: "THEG_CHATGPT",
    focal: true,
  },
  {
    id: "jobs",
    route: "/theg-movies/jobs",
    title: "Jobs",
    mobileLabel: "JOBS",
    bottomNavigation: true,
    searchScope: "THEG_JOBS",
    focal: true,
  },
] as const;

export function assertThegFiveTabs(tabs = THEG_MOVIES_LIBRARY_BOTTOM_NAV): void {
  const labels = tabs.map((t) => t.mobileLabel);
  const expected = ["HOME", "MOVIES", "SEARCH", "CHATGPT", "JOBS"];
  if (labels.length !== 5 || labels.join("|") !== expected.join("|")) {
    throw new Error(
      `THEG MOVIES LIBRARY bottom nav must be exactly ${expected.join("|")}; got ${labels.join("|")}`,
    );
  }
}
